import { Box, Card } from '@mui/material';
import styled from 'styled-components';

export const StyledModalBox = styled(Box)({
  width: '50%',
  height: '97%',
  margin: '1%',
  background: 'white',
  padding: '20px',
  borderRadius: '20px',
});
export const StyledDeleteCard = styled(Card)({
  top: '40%',
  width: '500px',
  left: '35%',
  right: '35%',
  padding: 25,
});